import React from 'react';
import { MessageDeletedProps } from 'stream-chat-react';

import { DateTime } from 'luxon';

import { Role } from '@common/components/RBAC';

import hasUserCorrectRole from '../utils/hasUserCorrectRole';
import * as Styled from './styled';

interface PropsType extends MessageDeletedProps {
	currentUserId: number;
}

function DeletedMessage({ message, currentUserId }: PropsType) {
	const { user, deleted_at: deletedAt } = message;

	if (hasUserCorrectRole(user.lms_roles as Role[])) {
		return null;
	}

	const isMyDeletedMessage = user?.id?.toString() === currentUserId.toString();

	const deletedAtValue = DateTime.fromJSDate(new Date(deletedAt)).toFormat('dd.MM.yy HH:mm');

	return (
		<div
			className={`str-chat__message
                ${isMyDeletedMessage ? 'str-chat__message--me' : 'str-chat__message--other'}
                str-chat__message-simple str-chat__message--deleted deleted`}
			data-testid="message-deleted-component"
		>
			<div className="str-chat__message--deleted-inner">The message was deleted</div>
			<Styled.DeletedTime className="str-chat__message-simple-timestamp" title={deletedAtValue}>
				{deletedAtValue}
			</Styled.DeletedTime>
		</div>
	);
}

export default DeletedMessage;
